module.exports = __webpack_public_path__ + "static/media/icons8-receive-cash-gray.7d4f1062.svg";